module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/82e2890b48df96037aeb0e965cdd1cee.gif";